<template>
  <div class="about">
    <svg class="about__logo" width="100" height="100">
      <use xlink:href="#normacs-logo" />
    </svg>
    <p class="about__title">{{ info.name }}</p>
    <p class="about__content">{{ info.description }}</p>
    <p class="about__content">{{ info.copyright }}.</p>
    <p class="about__content">{{ techInfo }}</p>
    <p v-for="(field, i) in customFields" :key="i" class="about__content">
      {{ field.label }}: {{ field.value }}
    </p>
  </div>
</template>

<script>
export default {
  data: () => ({
    currentAppVersion: __VERSION__
  }),

  computed: {
    /** @returns {ApiAppInfo} */
    info() {
      return this.$store.state.appInfo;
    },

    /** @returns {Object} */
    license() {
      return this.$store.state.auth.user.license;
    },

    techInfo() {
      return (
        `Версия ${this.info.version}/v${this.currentAppVersion}` +
        (this.license.serialNumber ? `, № ${this.license.serialNumber}` : '')
      );
    },

    customFields() {
      return this.info.customFields.concat(this.license.customFields);
    }
  }
};
</script>

<style src="./about.css" />
